import { Component, TemplateRef, ViewChild, forwardRef } from "@angular/core";
import { ToolBarToolComponent } from "@progress/kendo-angular-toolbar";

@Component({
    selector: "app-toolbar-slot",
    providers: [{ provide: ToolBarToolComponent, useExisting: forwardRef(() => ToolbarSlotComponent) }],
    template: `
        <ng-template #toolbarTemplate>
            <ng-content></ng-content>
        </ng-template>
    `,
})
export class ToolbarSlotComponent extends ToolBarToolComponent {
    @ViewChild("toolbarTemplate", { static: true }) override toolbarTemplate: TemplateRef<unknown> = undefined;
}
